'use strict';

var cov_266ufwtch6 = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\geographic_map\\geographic_mapCtrl.js',
      hash = '4f5ab3ff2adee794be451110c7403c7942fdf33c',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\geographic_map\\geographic_mapCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 314,
          column: 3
        }
      },
      '1': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 37
        }
      },
      '2': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 3
        }
      },
      '3': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 11
        }
      },
      '4': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 39
        }
      },
      '5': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 26
        }
      },
      '6': {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 32
        }
      },
      '7': {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 12,
          column: 35
        }
      },
      '8': {
        start: {
          line: 13,
          column: 15
        },
        end: {
          line: 13,
          column: 26
        }
      },
      '9': {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 14,
          column: 30
        }
      },
      '10': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 30
        }
      },
      '11': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 28
        }
      },
      '12': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 35
        }
      },
      '13': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 30
        }
      },
      '14': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 30
        }
      },
      '15': {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 34
        }
      },
      '16': {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 38
        }
      },
      '17': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 26
        }
      },
      '18': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 27
        }
      },
      '19': {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 28
        }
      },
      '20': {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 29
        }
      },
      '21': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 42,
          column: 4
        }
      },
      '22': {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 37
        }
      },
      '23': {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 48,
          column: 4
        }
      },
      '24': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 36
        }
      },
      '25': {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 40
        }
      },
      '26': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 39
        }
      },
      '27': {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 64,
          column: 4
        }
      },
      '28': {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      '29': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 41
        }
      },
      '30': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 63,
          column: 7
        }
      },
      '31': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 57,
          column: 7
        }
      },
      '32': {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 34
        }
      },
      '33': {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 72
        }
      },
      '34': {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 35
        }
      },
      '35': {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 62,
          column: 7
        }
      },
      '36': {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 44
        }
      },
      '37': {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 73,
          column: 4
        }
      },
      '38': {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 72,
          column: 7
        }
      },
      '39': {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 80,
          column: 4
        }
      },
      '40': {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      },
      '41': {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 88,
          column: 7
        }
      },
      '42': {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 98,
          column: 4
        }
      },
      '43': {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 97,
          column: 7
        }
      },
      '44': {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 109,
          column: 4
        }
      },
      '45': {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 108,
          column: 6
        }
      },
      '46': {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 111,
          column: 27
        }
      },
      '47': {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 112,
          column: 29
        }
      },
      '48': {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 113,
          column: 24
        }
      },
      '49': {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 114,
          column: 28
        }
      },
      '50': {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 115,
          column: 24
        }
      },
      '51': {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 116,
          column: 23
        }
      },
      '52': {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 127,
          column: 4
        }
      },
      '53': {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 30
        }
      },
      '54': {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 126,
          column: 7
        }
      },
      '55': {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 123,
          column: 7
        }
      },
      '56': {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 34
        }
      },
      '57': {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 48
        }
      },
      '58': {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 33
        }
      },
      '59': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 33
        }
      },
      '60': {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 132,
          column: 4
        }
      },
      '61': {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 131,
          column: 7
        }
      },
      '62': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 35
        }
      },
      '63': {
        start: {
          line: 133,
          column: 2
        },
        end: {
          line: 136,
          column: 4
        }
      },
      '64': {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 102
        }
      },
      '65': {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 36
        }
      },
      '66': {
        start: {
          line: 139,
          column: 19
        },
        end: {
          line: 143,
          column: 4
        }
      },
      '67': {
        start: {
          line: 144,
          column: 2
        },
        end: {
          line: 146,
          column: 4
        }
      },
      '68': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 22
        }
      },
      '69': {
        start: {
          line: 147,
          column: 2
        },
        end: {
          line: 149,
          column: 4
        }
      },
      '70': {
        start: {
          line: 150,
          column: 2
        },
        end: {
          line: 152,
          column: 4
        }
      },
      '71': {
        start: {
          line: 155,
          column: 2
        },
        end: {
          line: 155,
          column: 23
        }
      },
      '72': {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 258,
          column: 4
        }
      },
      '73': {
        start: {
          line: 158,
          column: 13
        },
        end: {
          line: 158,
          column: 15
        }
      },
      '74': {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 160,
          column: 29
        }
      },
      '75': {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      '76': {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 179,
          column: 8
        }
      },
      '77': {
        start: {
          line: 183,
          column: 11
        },
        end: {
          line: 234,
          column: 5
        }
      },
      '78': {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 198,
          column: 8
        }
      },
      '79': {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 209,
          column: 7
        }
      },
      '80': {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 208,
          column: 9
        }
      },
      '81': {
        start: {
          line: 201,
          column: 10
        },
        end: {
          line: 201,
          column: 53
        }
      },
      '82': {
        start: {
          line: 202,
          column: 10
        },
        end: {
          line: 202,
          column: 45
        }
      },
      '83': {
        start: {
          line: 203,
          column: 10
        },
        end: {
          line: 203,
          column: 58
        }
      },
      '84': {
        start: {
          line: 207,
          column: 10
        },
        end: {
          line: 207,
          column: 16
        }
      },
      '85': {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 225,
          column: 8
        }
      },
      '86': {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 233,
          column: 7
        }
      },
      '87': {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 232,
          column: 9
        }
      },
      '88': {
        start: {
          line: 228,
          column: 10
        },
        end: {
          line: 228,
          column: 41
        }
      },
      '89': {
        start: {
          line: 229,
          column: 10
        },
        end: {
          line: 229,
          column: 58
        }
      },
      '90': {
        start: {
          line: 231,
          column: 10
        },
        end: {
          line: 231,
          column: 16
        }
      },
      '91': {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 235,
          column: 19
        }
      },
      '92': {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 244,
          column: 5
        }
      },
      '93': {
        start: {
          line: 237,
          column: 6
        },
        end: {
          line: 243,
          column: 7
        }
      },
      '94': {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 242,
          column: 11
        }
      },
      '95': {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 245,
          column: 25
        }
      },
      '96': {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 250,
          column: 5
        }
      },
      '97': {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 247,
          column: 24
        }
      },
      '98': {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 249,
          column: 63
        }
      },
      '99': {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 257,
          column: 7
        }
      },
      '100': {
        start: {
          line: 259,
          column: 2
        },
        end: {
          line: 302,
          column: 4
        }
      },
      '101': {
        start: {
          line: 260,
          column: 22
        },
        end: {
          line: 260,
          column: 31
        }
      },
      '102': {
        start: {
          line: 261,
          column: 4
        },
        end: {
          line: 301,
          column: 7
        }
      },
      '103': {
        start: {
          line: 272,
          column: 6
        },
        end: {
          line: 274,
          column: 7
        }
      },
      '104': {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 273,
          column: 15
        }
      },
      '105': {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 275,
          column: 26
        }
      },
      '106': {
        start: {
          line: 276,
          column: 27
        },
        end: {
          line: 288,
          column: 7
        }
      },
      '107': {
        start: {
          line: 289,
          column: 6
        },
        end: {
          line: 300,
          column: 9
        }
      },
      '108': {
        start: {
          line: 290,
          column: 8
        },
        end: {
          line: 290,
          column: 30
        }
      },
      '109': {
        start: {
          line: 291,
          column: 8
        },
        end: {
          line: 298,
          column: 9
        }
      },
      '110': {
        start: {
          line: 292,
          column: 10
        },
        end: {
          line: 295,
          column: 13
        }
      },
      '111': {
        start: {
          line: 296,
          column: 10
        },
        end: {
          line: 296,
          column: 35
        }
      },
      '112': {
        start: {
          line: 297,
          column: 10
        },
        end: {
          line: 297,
          column: 17
        }
      },
      '113': {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 299,
          column: 40
        }
      },
      '114': {
        start: {
          line: 304,
          column: 2
        },
        end: {
          line: 308,
          column: 4
        }
      },
      '115': {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 305,
          column: 25
        }
      },
      '116': {
        start: {
          line: 306,
          column: 4
        },
        end: {
          line: 306,
          column: 30
        }
      },
      '117': {
        start: {
          line: 307,
          column: 4
        },
        end: {
          line: 307,
          column: 39
        }
      },
      '118': {
        start: {
          line: 310,
          column: 2
        },
        end: {
          line: 310,
          column: 23
        }
      },
      '119': {
        start: {
          line: 311,
          column: 2
        },
        end: {
          line: 311,
          column: 28
        }
      },
      '120': {
        start: {
          line: 312,
          column: 2
        },
        end: {
          line: 312,
          column: 20
        }
      },
      '121': {
        start: {
          line: 317,
          column: 2
        },
        end: {
          line: 320,
          column: 4
        }
      },
      '122': {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 318,
          column: 24
        }
      },
      '123': {
        start: {
          line: 319,
          column: 4
        },
        end: {
          line: 319,
          column: 40
        }
      },
      '124': {
        start: {
          line: 321,
          column: 2
        },
        end: {
          line: 327,
          column: 4
        }
      },
      '125': {
        start: {
          line: 322,
          column: 22
        },
        end: {
          line: 322,
          column: 49
        }
      },
      '126': {
        start: {
          line: 323,
          column: 4
        },
        end: {
          line: 325,
          column: 5
        }
      },
      '127': {
        start: {
          line: 324,
          column: 6
        },
        end: {
          line: 324,
          column: 18
        }
      },
      '128': {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 326,
          column: 17
        }
      },
      '129': {
        start: {
          line: 328,
          column: 2
        },
        end: {
          line: 388,
          column: 4
        }
      },
      '130': {
        start: {
          line: 339,
          column: 4
        },
        end: {
          line: 341,
          column: 5
        }
      },
      '131': {
        start: {
          line: 340,
          column: 6
        },
        end: {
          line: 340,
          column: 13
        }
      },
      '132': {
        start: {
          line: 342,
          column: 4
        },
        end: {
          line: 342,
          column: 76
        }
      },
      '133': {
        start: {
          line: 343,
          column: 4
        },
        end: {
          line: 345,
          column: 5
        }
      },
      '134': {
        start: {
          line: 344,
          column: 6
        },
        end: {
          line: 344,
          column: 13
        }
      },
      '135': {
        start: {
          line: 346,
          column: 4
        },
        end: {
          line: 346,
          column: 30
        }
      },
      '136': {
        start: {
          line: 347,
          column: 14
        },
        end: {
          line: 361,
          column: 5
        }
      },
      '137': {
        start: {
          line: 362,
          column: 4
        },
        end: {
          line: 364,
          column: 5
        }
      },
      '138': {
        start: {
          line: 363,
          column: 6
        },
        end: {
          line: 363,
          column: 52
        }
      },
      '139': {
        start: {
          line: 366,
          column: 4
        },
        end: {
          line: 387,
          column: 7
        }
      },
      '140': {
        start: {
          line: 367,
          column: 6
        },
        end: {
          line: 367,
          column: 33
        }
      },
      '141': {
        start: {
          line: 368,
          column: 6
        },
        end: {
          line: 370,
          column: 7
        }
      },
      '142': {
        start: {
          line: 369,
          column: 8
        },
        end: {
          line: 369,
          column: 15
        }
      },
      '143': {
        start: {
          line: 371,
          column: 20
        },
        end: {
          line: 371,
          column: 24
        }
      },
      '144': {
        start: {
          line: 372,
          column: 6
        },
        end: {
          line: 385,
          column: 7
        }
      },
      '145': {
        start: {
          line: 373,
          column: 23
        },
        end: {
          line: 373,
          column: 90
        }
      },
      '146': {
        start: {
          line: 374,
          column: 8
        },
        end: {
          line: 382,
          column: 9
        }
      },
      '147': {
        start: {
          line: 375,
          column: 10
        },
        end: {
          line: 375,
          column: 22
        }
      },
      '148': {
        start: {
          line: 376,
          column: 10
        },
        end: {
          line: 376,
          column: 91
        }
      },
      '149': {
        start: {
          line: 377,
          column: 15
        },
        end: {
          line: 382,
          column: 9
        }
      },
      '150': {
        start: {
          line: 378,
          column: 10
        },
        end: {
          line: 378,
          column: 22
        }
      },
      '151': {
        start: {
          line: 379,
          column: 10
        },
        end: {
          line: 379,
          column: 66
        }
      },
      '152': {
        start: {
          line: 381,
          column: 10
        },
        end: {
          line: 381,
          column: 42
        }
      },
      '153': {
        start: {
          line: 384,
          column: 8
        },
        end: {
          line: 384,
          column: 89
        }
      },
      '154': {
        start: {
          line: 386,
          column: 6
        },
        end: {
          line: 386,
          column: 26
        }
      },
      '155': {
        start: {
          line: 392,
          column: 2
        },
        end: {
          line: 506,
          column: 4
        }
      },
      '156': {
        start: {
          line: 395,
          column: 6
        },
        end: {
          line: 399,
          column: 9
        }
      },
      '157': {
        start: {
          line: 402,
          column: 6
        },
        end: {
          line: 402,
          column: 45
        }
      },
      '158': {
        start: {
          line: 403,
          column: 6
        },
        end: {
          line: 403,
          column: 43
        }
      },
      '159': {
        start: {
          line: 404,
          column: 6
        },
        end: {
          line: 404,
          column: 78
        }
      },
      '160': {
        start: {
          line: 405,
          column: 6
        },
        end: {
          line: 407,
          column: 7
        }
      },
      '161': {
        start: {
          line: 406,
          column: 8
        },
        end: {
          line: 406,
          column: 56
        }
      },
      '162': {
        start: {
          line: 408,
          column: 6
        },
        end: {
          line: 432,
          column: 7
        }
      },
      '163': {
        start: {
          line: 409,
          column: 8
        },
        end: {
          line: 409,
          column: 41
        }
      },
      '164': {
        start: {
          line: 410,
          column: 8
        },
        end: {
          line: 414,
          column: 9
        }
      },
      '165': {
        start: {
          line: 411,
          column: 10
        },
        end: {
          line: 411,
          column: 42
        }
      },
      '166': {
        start: {
          line: 413,
          column: 10
        },
        end: {
          line: 413,
          column: 104
        }
      },
      '167': {
        start: {
          line: 416,
          column: 8
        },
        end: {
          line: 431,
          column: 9
        }
      },
      '168': {
        start: {
          line: 417,
          column: 21
        },
        end: {
          line: 417,
          column: 43
        }
      },
      '169': {
        start: {
          line: 418,
          column: 10
        },
        end: {
          line: 430,
          column: 11
        }
      },
      '170': {
        start: {
          line: 419,
          column: 12
        },
        end: {
          line: 423,
          column: 13
        }
      },
      '171': {
        start: {
          line: 420,
          column: 14
        },
        end: {
          line: 420,
          column: 46
        }
      },
      '172': {
        start: {
          line: 422,
          column: 14
        },
        end: {
          line: 422,
          column: 83
        }
      },
      '173': {
        start: {
          line: 424,
          column: 12
        },
        end: {
          line: 428,
          column: 13
        }
      },
      '174': {
        start: {
          line: 425,
          column: 14
        },
        end: {
          line: 425,
          column: 47
        }
      },
      '175': {
        start: {
          line: 427,
          column: 14
        },
        end: {
          line: 427,
          column: 83
        }
      },
      '176': {
        start: {
          line: 429,
          column: 12
        },
        end: {
          line: 429,
          column: 18
        }
      },
      '177': {
        start: {
          line: 435,
          column: 6
        },
        end: {
          line: 435,
          column: 31
        }
      },
      '178': {
        start: {
          line: 438,
          column: 19
        },
        end: {
          line: 438,
          column: 50
        }
      },
      '179': {
        start: {
          line: 439,
          column: 6
        },
        end: {
          line: 457,
          column: 9
        }
      },
      '180': {
        start: {
          line: 440,
          column: 8
        },
        end: {
          line: 446,
          column: 9
        }
      },
      '181': {
        start: {
          line: 441,
          column: 10
        },
        end: {
          line: 444,
          column: 13
        }
      },
      '182': {
        start: {
          line: 445,
          column: 10
        },
        end: {
          line: 445,
          column: 17
        }
      },
      '183': {
        start: {
          line: 447,
          column: 8
        },
        end: {
          line: 453,
          column: 9
        }
      },
      '184': {
        start: {
          line: 448,
          column: 10
        },
        end: {
          line: 451,
          column: 13
        }
      },
      '185': {
        start: {
          line: 452,
          column: 10
        },
        end: {
          line: 452,
          column: 17
        }
      },
      '186': {
        start: {
          line: 454,
          column: 8
        },
        end: {
          line: 454,
          column: 37
        }
      },
      '187': {
        start: {
          line: 455,
          column: 8
        },
        end: {
          line: 455,
          column: 59
        }
      },
      '188': {
        start: {
          line: 456,
          column: 8
        },
        end: {
          line: 456,
          column: 26
        }
      },
      '189': {
        start: {
          line: 460,
          column: 6
        },
        end: {
          line: 462,
          column: 7
        }
      },
      '190': {
        start: {
          line: 461,
          column: 8
        },
        end: {
          line: 461,
          column: 15
        }
      },
      '191': {
        start: {
          line: 463,
          column: 23
        },
        end: {
          line: 463,
          column: 25
        }
      },
      '192': {
        start: {
          line: 464,
          column: 6
        },
        end: {
          line: 468,
          column: 7
        }
      },
      '193': {
        start: {
          line: 465,
          column: 8
        },
        end: {
          line: 467,
          column: 9
        }
      },
      '194': {
        start: {
          line: 466,
          column: 10
        },
        end: {
          line: 466,
          column: 31
        }
      },
      '195': {
        start: {
          line: 469,
          column: 6
        },
        end: {
          line: 471,
          column: 9
        }
      },
      '196': {
        start: {
          line: 470,
          column: 8
        },
        end: {
          line: 470,
          column: 34
        }
      },
      '197': {
        start: {
          line: 474,
          column: 6
        },
        end: {
          line: 501,
          column: 9
        }
      },
      '198': {
        start: {
          line: 485,
          column: 8
        },
        end: {
          line: 487,
          column: 9
        }
      },
      '199': {
        start: {
          line: 486,
          column: 10
        },
        end: {
          line: 486,
          column: 17
        }
      },
      '200': {
        start: {
          line: 488,
          column: 8
        },
        end: {
          line: 488,
          column: 34
        }
      },
      '201': {
        start: {
          line: 489,
          column: 8
        },
        end: {
          line: 500,
          column: 11
        }
      },
      '202': {
        start: {
          line: 490,
          column: 10
        },
        end: {
          line: 490,
          column: 37
        }
      },
      '203': {
        start: {
          line: 491,
          column: 10
        },
        end: {
          line: 497,
          column: 11
        }
      },
      '204': {
        start: {
          line: 492,
          column: 12
        },
        end: {
          line: 495,
          column: 15
        }
      },
      '205': {
        start: {
          line: 496,
          column: 12
        },
        end: {
          line: 496,
          column: 19
        }
      },
      '206': {
        start: {
          line: 498,
          column: 10
        },
        end: {
          line: 498,
          column: 28
        }
      },
      '207': {
        start: {
          line: 499,
          column: 10
        },
        end: {
          line: 499,
          column: 36
        }
      },
      '208': {
        start: {
          line: 504,
          column: 6
        },
        end: {
          line: 504,
          column: 42
        }
      },
      '209': {
        start: {
          line: 510,
          column: 2
        },
        end: {
          line: 577,
          column: 4
        }
      },
      '210': {
        start: {
          line: 513,
          column: 6
        },
        end: {
          line: 520,
          column: 9
        }
      },
      '211': {
        start: {
          line: 523,
          column: 6
        },
        end: {
          line: 523,
          column: 45
        }
      },
      '212': {
        start: {
          line: 526,
          column: 6
        },
        end: {
          line: 526,
          column: 31
        }
      },
      '213': {
        start: {
          line: 530,
          column: 19
        },
        end: {
          line: 530,
          column: 50
        }
      },
      '214': {
        start: {
          line: 531,
          column: 6
        },
        end: {
          line: 531,
          column: 39
        }
      },
      '215': {
        start: {
          line: 532,
          column: 6
        },
        end: {
          line: 532,
          column: 35
        }
      },
      '216': {
        start: {
          line: 533,
          column: 6
        },
        end: {
          line: 533,
          column: 28
        }
      },
      '217': {
        start: {
          line: 534,
          column: 6
        },
        end: {
          line: 541,
          column: 9
        }
      },
      '218': {
        start: {
          line: 535,
          column: 8
        },
        end: {
          line: 535,
          column: 44
        }
      },
      '219': {
        start: {
          line: 536,
          column: 8
        },
        end: {
          line: 538,
          column: 9
        }
      },
      '220': {
        start: {
          line: 537,
          column: 10
        },
        end: {
          line: 537,
          column: 17
        }
      },
      '221': {
        start: {
          line: 539,
          column: 8
        },
        end: {
          line: 539,
          column: 34
        }
      },
      '222': {
        start: {
          line: 540,
          column: 8
        },
        end: {
          line: 540,
          column: 39
        }
      },
      '223': {
        start: {
          line: 544,
          column: 6
        },
        end: {
          line: 570,
          column: 9
        }
      },
      '224': {
        start: {
          line: 555,
          column: 8
        },
        end: {
          line: 557,
          column: 9
        }
      },
      '225': {
        start: {
          line: 556,
          column: 10
        },
        end: {
          line: 556,
          column: 17
        }
      },
      '226': {
        start: {
          line: 558,
          column: 8
        },
        end: {
          line: 558,
          column: 34
        }
      },
      '227': {
        start: {
          line: 559,
          column: 8
        },
        end: {
          line: 569,
          column: 11
        }
      },
      '228': {
        start: {
          line: 560,
          column: 10
        },
        end: {
          line: 560,
          column: 37
        }
      },
      '229': {
        start: {
          line: 561,
          column: 10
        },
        end: {
          line: 567,
          column: 11
        }
      },
      '230': {
        start: {
          line: 562,
          column: 12
        },
        end: {
          line: 565,
          column: 15
        }
      },
      '231': {
        start: {
          line: 566,
          column: 12
        },
        end: {
          line: 566,
          column: 19
        }
      },
      '232': {
        start: {
          line: 568,
          column: 10
        },
        end: {
          line: 568,
          column: 36
        }
      },
      '233': {
        start: {
          line: 574,
          column: 6
        },
        end: {
          line: 574,
          column: 42
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 55
          },
          end: {
            line: 4,
            column: 56
          }
        },
        loc: {
          start: {
            line: 4,
            column: 186
          },
          end: {
            line: 314,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 44,
            column: 24
          },
          end: {
            line: 44,
            column: 25
          }
        },
        loc: {
          start: {
            line: 44,
            column: 36
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 44
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 49,
            column: 28
          },
          end: {
            line: 49,
            column: 29
          }
        },
        loc: {
          start: {
            line: 49,
            column: 40
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 49
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 53,
            column: 56
          },
          end: {
            line: 53,
            column: 57
          }
        },
        loc: {
          start: {
            line: 53,
            column: 64
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 53
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 65,
            column: 26
          },
          end: {
            line: 65,
            column: 27
          }
        },
        loc: {
          start: {
            line: 65,
            column: 38
          },
          end: {
            line: 73,
            column: 3
          }
        },
        line: 65
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 81,
            column: 24
          },
          end: {
            line: 81,
            column: 25
          }
        },
        loc: {
          start: {
            line: 81,
            column: 36
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 81
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 90,
            column: 27
          },
          end: {
            line: 90,
            column: 28
          }
        },
        loc: {
          start: {
            line: 90,
            column: 39
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 90
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 100,
            column: 22
          },
          end: {
            line: 100,
            column: 23
          }
        },
        loc: {
          start: {
            line: 100,
            column: 38
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 100
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 117,
            column: 20
          },
          end: {
            line: 117,
            column: 21
          }
        },
        loc: {
          start: {
            line: 117,
            column: 32
          },
          end: {
            line: 127,
            column: 3
          }
        },
        line: 117
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 119,
            column: 53
          },
          end: {
            line: 119,
            column: 54
          }
        },
        loc: {
          start: {
            line: 119,
            column: 61
          },
          end: {
            line: 126,
            column: 5
          }
        },
        line: 119
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 128,
            column: 23
          },
          end: {
            line: 128,
            column: 24
          }
        },
        loc: {
          start: {
            line: 128,
            column: 35
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 128
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 129,
            column: 65
          },
          end: {
            line: 129,
            column: 66
          }
        },
        loc: {
          start: {
            line: 129,
            column: 73
          },
          end: {
            line: 131,
            column: 5
          }
        },
        line: 129
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 133,
            column: 25
          },
          end: {
            line: 133,
            column: 26
          }
        },
        loc: {
          start: {
            line: 133,
            column: 42
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 133
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 144,
            column: 31
          },
          end: {
            line: 144,
            column: 32
          }
        },
        loc: {
          start: {
            line: 144,
            column: 51
          },
          end: {
            line: 146,
            column: 3
          }
        },
        line: 144
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 147,
            column: 27
          },
          end: {
            line: 147,
            column: 28
          }
        },
        loc: {
          start: {
            line: 147,
            column: 74
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 147
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 150,
            column: 25
          },
          end: {
            line: 150,
            column: 26
          }
        },
        loc: {
          start: {
            line: 150,
            column: 72
          },
          end: {
            line: 152,
            column: 3
          }
        },
        line: 150
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 157,
            column: 16
          },
          end: {
            line: 157,
            column: 17
          }
        },
        loc: {
          start: {
            line: 157,
            column: 38
          },
          end: {
            line: 258,
            column: 3
          }
        },
        line: 157
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 259,
            column: 22
          },
          end: {
            line: 259,
            column: 23
          }
        },
        loc: {
          start: {
            line: 259,
            column: 38
          },
          end: {
            line: 302,
            column: 3
          }
        },
        line: 259
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 271,
            column: 7
          },
          end: {
            line: 271,
            column: 8
          }
        },
        loc: {
          start: {
            line: 271,
            column: 20
          },
          end: {
            line: 301,
            column: 5
          }
        },
        line: 271
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 289,
            column: 97
          },
          end: {
            line: 289,
            column: 98
          }
        },
        loc: {
          start: {
            line: 289,
            column: 105
          },
          end: {
            line: 300,
            column: 7
          }
        },
        line: 289
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 304,
            column: 22
          },
          end: {
            line: 304,
            column: 23
          }
        },
        loc: {
          start: {
            line: 304,
            column: 34
          },
          end: {
            line: 308,
            column: 3
          }
        },
        line: 304
      },
      '21': {
        name: 'geographic_mapCtrl_edit',
        decl: {
          start: {
            line: 316,
            column: 9
          },
          end: {
            line: 316,
            column: 32
          }
        },
        loc: {
          start: {
            line: 316,
            column: 99
          },
          end: {
            line: 389,
            column: 1
          }
        },
        line: 316
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 317,
            column: 22
          },
          end: {
            line: 317,
            column: 23
          }
        },
        loc: {
          start: {
            line: 317,
            column: 34
          },
          end: {
            line: 320,
            column: 3
          }
        },
        line: 317
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 321,
            column: 21
          },
          end: {
            line: 321,
            column: 22
          }
        },
        loc: {
          start: {
            line: 321,
            column: 33
          },
          end: {
            line: 327,
            column: 3
          }
        },
        line: 321
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 328,
            column: 24
          },
          end: {
            line: 328,
            column: 25
          }
        },
        loc: {
          start: {
            line: 328,
            column: 36
          },
          end: {
            line: 388,
            column: 3
          }
        },
        line: 328
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 366,
            column: 88
          },
          end: {
            line: 366,
            column: 89
          }
        },
        loc: {
          start: {
            line: 366,
            column: 96
          },
          end: {
            line: 387,
            column: 5
          }
        },
        line: 366
      },
      '26': {
        name: 'geographic_mapCtrl_level',
        decl: {
          start: {
            line: 391,
            column: 9
          },
          end: {
            line: 391,
            column: 33
          }
        },
        loc: {
          start: {
            line: 391,
            column: 127
          },
          end: {
            line: 507,
            column: 1
          }
        },
        line: 391
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 439,
            column: 93
          },
          end: {
            line: 439,
            column: 94
          }
        },
        loc: {
          start: {
            line: 439,
            column: 101
          },
          end: {
            line: 457,
            column: 7
          }
        },
        line: 439
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 469,
            column: 109
          },
          end: {
            line: 469,
            column: 110
          }
        },
        loc: {
          start: {
            line: 469,
            column: 117
          },
          end: {
            line: 471,
            column: 7
          }
        },
        line: 469
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 484,
            column: 9
          },
          end: {
            line: 484,
            column: 10
          }
        },
        loc: {
          start: {
            line: 484,
            column: 22
          },
          end: {
            line: 501,
            column: 7
          }
        },
        line: 484
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 489,
            column: 91
          },
          end: {
            line: 489,
            column: 92
          }
        },
        loc: {
          start: {
            line: 489,
            column: 99
          },
          end: {
            line: 500,
            column: 9
          }
        },
        line: 489
      },
      '31': {
        name: 'geographic_mapCtrl_champ',
        decl: {
          start: {
            line: 509,
            column: 9
          },
          end: {
            line: 509,
            column: 33
          }
        },
        loc: {
          start: {
            line: 509,
            column: 108
          },
          end: {
            line: 578,
            column: 1
          }
        },
        line: 509
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 534,
            column: 96
          },
          end: {
            line: 534,
            column: 97
          }
        },
        loc: {
          start: {
            line: 534,
            column: 104
          },
          end: {
            line: 541,
            column: 7
          }
        },
        line: 534
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 554,
            column: 9
          },
          end: {
            line: 554,
            column: 10
          }
        },
        loc: {
          start: {
            line: 554,
            column: 22
          },
          end: {
            line: 570,
            column: 7
          }
        },
        line: 554
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 559,
            column: 94
          },
          end: {
            line: 559,
            column: 95
          }
        },
        loc: {
          start: {
            line: 559,
            column: 102
          },
          end: {
            line: 569,
            column: 9
          }
        },
        line: 559
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }, {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }],
        line: 6
      },
      '1': {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 50
      },
      '2': {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }],
        line: 60
      },
      '3': {
        loc: {
          start: {
            line: 134,
            column: 34
          },
          end: {
            line: 134,
            column: 101
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 134,
            column: 65
          },
          end: {
            line: 134,
            column: 93
          }
        }, {
          start: {
            line: 134,
            column: 96
          },
          end: {
            line: 134,
            column: 101
          }
        }],
        line: 134
      },
      '4': {
        loc: {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 162
      },
      '5': {
        loc: {
          start: {
            line: 183,
            column: 11
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 11
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 183,
            column: 11
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 183
      },
      '6': {
        loc: {
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        }, {
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        }],
        line: 200
      },
      '7': {
        loc: {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 232,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 232,
            column: 9
          }
        }, {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 232,
            column: 9
          }
        }],
        line: 227
      },
      '8': {
        loc: {
          start: {
            line: 237,
            column: 6
          },
          end: {
            line: 243,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 237,
            column: 6
          },
          end: {
            line: 243,
            column: 7
          }
        }, {
          start: {
            line: 237,
            column: 6
          },
          end: {
            line: 243,
            column: 7
          }
        }],
        line: 237
      },
      '9': {
        loc: {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        }, {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        }],
        line: 246
      },
      '10': {
        loc: {
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 246,
            column: 37
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 246,
            column: 24
          }
        }, {
          start: {
            line: 246,
            column: 28
          },
          end: {
            line: 246,
            column: 37
          }
        }],
        line: 246
      },
      '11': {
        loc: {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 274,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 274,
            column: 7
          }
        }, {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 274,
            column: 7
          }
        }],
        line: 272
      },
      '12': {
        loc: {
          start: {
            line: 291,
            column: 8
          },
          end: {
            line: 298,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 291,
            column: 8
          },
          end: {
            line: 298,
            column: 9
          }
        }, {
          start: {
            line: 291,
            column: 8
          },
          end: {
            line: 298,
            column: 9
          }
        }],
        line: 291
      },
      '13': {
        loc: {
          start: {
            line: 323,
            column: 4
          },
          end: {
            line: 325,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 323,
            column: 4
          },
          end: {
            line: 325,
            column: 5
          }
        }, {
          start: {
            line: 323,
            column: 4
          },
          end: {
            line: 325,
            column: 5
          }
        }],
        line: 323
      },
      '14': {
        loc: {
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 341,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 341,
            column: 5
          }
        }, {
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 341,
            column: 5
          }
        }],
        line: 339
      },
      '15': {
        loc: {
          start: {
            line: 343,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 343,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        }, {
          start: {
            line: 343,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        }],
        line: 343
      },
      '16': {
        loc: {
          start: {
            line: 368,
            column: 6
          },
          end: {
            line: 370,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 368,
            column: 6
          },
          end: {
            line: 370,
            column: 7
          }
        }, {
          start: {
            line: 368,
            column: 6
          },
          end: {
            line: 370,
            column: 7
          }
        }],
        line: 368
      },
      '17': {
        loc: {
          start: {
            line: 372,
            column: 6
          },
          end: {
            line: 385,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 372,
            column: 6
          },
          end: {
            line: 385,
            column: 7
          }
        }, {
          start: {
            line: 372,
            column: 6
          },
          end: {
            line: 385,
            column: 7
          }
        }],
        line: 372
      },
      '18': {
        loc: {
          start: {
            line: 374,
            column: 8
          },
          end: {
            line: 382,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 374,
            column: 8
          },
          end: {
            line: 382,
            column: 9
          }
        }, {
          start: {
            line: 374,
            column: 8
          },
          end: {
            line: 382,
            column: 9
          }
        }],
        line: 374
      },
      '19': {
        loc: {
          start: {
            line: 377,
            column: 15
          },
          end: {
            line: 382,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 377,
            column: 15
          },
          end: {
            line: 382,
            column: 9
          }
        }, {
          start: {
            line: 377,
            column: 15
          },
          end: {
            line: 382,
            column: 9
          }
        }],
        line: 377
      },
      '20': {
        loc: {
          start: {
            line: 397,
            column: 17
          },
          end: {
            line: 397,
            column: 118
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 397,
            column: 51
          },
          end: {
            line: 397,
            column: 52
          }
        }, {
          start: {
            line: 397,
            column: 55
          },
          end: {
            line: 397,
            column: 118
          }
        }],
        line: 397
      },
      '21': {
        loc: {
          start: {
            line: 408,
            column: 6
          },
          end: {
            line: 432,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 408,
            column: 6
          },
          end: {
            line: 432,
            column: 7
          }
        }, {
          start: {
            line: 408,
            column: 6
          },
          end: {
            line: 432,
            column: 7
          }
        }],
        line: 408
      },
      '22': {
        loc: {
          start: {
            line: 410,
            column: 8
          },
          end: {
            line: 414,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 410,
            column: 8
          },
          end: {
            line: 414,
            column: 9
          }
        }, {
          start: {
            line: 410,
            column: 8
          },
          end: {
            line: 414,
            column: 9
          }
        }],
        line: 410
      },
      '23': {
        loc: {
          start: {
            line: 418,
            column: 10
          },
          end: {
            line: 430,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 418,
            column: 10
          },
          end: {
            line: 430,
            column: 11
          }
        }, {
          start: {
            line: 418,
            column: 10
          },
          end: {
            line: 430,
            column: 11
          }
        }],
        line: 418
      },
      '24': {
        loc: {
          start: {
            line: 419,
            column: 12
          },
          end: {
            line: 423,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 419,
            column: 12
          },
          end: {
            line: 423,
            column: 13
          }
        }, {
          start: {
            line: 419,
            column: 12
          },
          end: {
            line: 423,
            column: 13
          }
        }],
        line: 419
      },
      '25': {
        loc: {
          start: {
            line: 424,
            column: 12
          },
          end: {
            line: 428,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 424,
            column: 12
          },
          end: {
            line: 428,
            column: 13
          }
        }, {
          start: {
            line: 424,
            column: 12
          },
          end: {
            line: 428,
            column: 13
          }
        }],
        line: 424
      },
      '26': {
        loc: {
          start: {
            line: 440,
            column: 8
          },
          end: {
            line: 446,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 440,
            column: 8
          },
          end: {
            line: 446,
            column: 9
          }
        }, {
          start: {
            line: 440,
            column: 8
          },
          end: {
            line: 446,
            column: 9
          }
        }],
        line: 440
      },
      '27': {
        loc: {
          start: {
            line: 440,
            column: 12
          },
          end: {
            line: 440,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 440,
            column: 12
          },
          end: {
            line: 440,
            column: 21
          }
        }, {
          start: {
            line: 440,
            column: 25
          },
          end: {
            line: 440,
            column: 35
          }
        }],
        line: 440
      },
      '28': {
        loc: {
          start: {
            line: 447,
            column: 8
          },
          end: {
            line: 453,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 447,
            column: 8
          },
          end: {
            line: 453,
            column: 9
          }
        }, {
          start: {
            line: 447,
            column: 8
          },
          end: {
            line: 453,
            column: 9
          }
        }],
        line: 447
      },
      '29': {
        loc: {
          start: {
            line: 455,
            column: 42
          },
          end: {
            line: 455,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 455,
            column: 42
          },
          end: {
            line: 455,
            column: 49
          }
        }, {
          start: {
            line: 455,
            column: 53
          },
          end: {
            line: 455,
            column: 57
          }
        }],
        line: 455
      },
      '30': {
        loc: {
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 462,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 462,
            column: 7
          }
        }, {
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 462,
            column: 7
          }
        }],
        line: 460
      },
      '31': {
        loc: {
          start: {
            line: 465,
            column: 8
          },
          end: {
            line: 467,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 465,
            column: 8
          },
          end: {
            line: 467,
            column: 9
          }
        }, {
          start: {
            line: 465,
            column: 8
          },
          end: {
            line: 467,
            column: 9
          }
        }],
        line: 465
      },
      '32': {
        loc: {
          start: {
            line: 485,
            column: 8
          },
          end: {
            line: 487,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 485,
            column: 8
          },
          end: {
            line: 487,
            column: 9
          }
        }, {
          start: {
            line: 485,
            column: 8
          },
          end: {
            line: 487,
            column: 9
          }
        }],
        line: 485
      },
      '33': {
        loc: {
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 497,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 497,
            column: 11
          }
        }, {
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 497,
            column: 11
          }
        }],
        line: 491
      },
      '34': {
        loc: {
          start: {
            line: 536,
            column: 8
          },
          end: {
            line: 538,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 536,
            column: 8
          },
          end: {
            line: 538,
            column: 9
          }
        }, {
          start: {
            line: 536,
            column: 8
          },
          end: {
            line: 538,
            column: 9
          }
        }],
        line: 536
      },
      '35': {
        loc: {
          start: {
            line: 555,
            column: 8
          },
          end: {
            line: 557,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 555,
            column: 8
          },
          end: {
            line: 557,
            column: 9
          }
        }, {
          start: {
            line: 555,
            column: 8
          },
          end: {
            line: 557,
            column: 9
          }
        }],
        line: 555
      },
      '36': {
        loc: {
          start: {
            line: 561,
            column: 10
          },
          end: {
            line: 567,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 561,
            column: 10
          },
          end: {
            line: 567,
            column: 11
          }
        }, {
          start: {
            line: 561,
            column: 10
          },
          end: {
            line: 567,
            column: 11
          }
        }],
        line: 561
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_266ufwtch6.s[0]++;
/**
* Geographic Map - controller
*/
angular.module('app').controller('geographic_mapCtrl', function ($scope, SweetAlert, $deltaLocation, FileUploader, $rootScope, $translate, $CRUDService, $otherHttpService, $filter, $uibModal) {
  cov_266ufwtch6.f[0]++;
  cov_266ufwtch6.s[1]++;

  $rootScope.processPageRight('1_4');
  cov_266ufwtch6.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_266ufwtch6.b[0][0]++;
    cov_266ufwtch6.s[3]++;

    return;
  } else {
    cov_266ufwtch6.b[0][1]++;
  }
  cov_266ufwtch6.s[4]++;
  $deltaLocation.addController($scope);
  cov_266ufwtch6.s[5]++;
  $scope.PATH = 'Periode';
  var EXPAND = (cov_266ufwtch6.s[6]++, 'fa-angle-down');
  var COLLAPSE = (cov_266ufwtch6.s[7]++, 'fa-angle-right');
  var LEAF = (cov_266ufwtch6.s[8]++, 'fa-circle');
  var LOADING = (cov_266ufwtch6.s[9]++, 'fa-spinner');
  cov_266ufwtch6.s[10]++;
  $scope.idScope = $scope.$id;
  cov_266ufwtch6.s[11]++;
  $scope.editOption = false;
  // Champ Personnalisé
  cov_266ufwtch6.s[12]++;
  $scope.PATHCHAMP = 'ChampsPerso';
  cov_266ufwtch6.s[13]++;
  $scope.PATHNG = 'NiveauGeo';
  cov_266ufwtch6.s[14]++;
  $scope.PATHPG = 'Localites';
  cov_266ufwtch6.s[15]++;
  $scope.show_champsperso = false;
  cov_266ufwtch6.s[16]++;
  $scope.show_geographiclevel = false;
  cov_266ufwtch6.s[17]++;
  $scope.isloading = true;
  cov_266ufwtch6.s[18]++;
  $scope.listLocalite = [];
  cov_266ufwtch6.s[19]++;
  $scope.isloadingCP = true;
  // Champs Personnalisé
  cov_266ufwtch6.s[20]++;
  $scope.listChampPerso = [];
  cov_266ufwtch6.s[21]++;
  $scope.listAggregation = [{
    label: $translate.instant('GEOGRAPHIC_PLAN.SUM'),
    id: '1'
  }, {
    label: $translate.instant('GEOGRAPHIC_PLAN.MOY'),
    id: '2'
  }, {
    label: $translate.instant('GEOGRAPHIC_PLAN.MAXI'),
    id: '3'
  }, {
    label: $translate.instant('GEOGRAPHIC_PLAN.MINI'),
    id: '4'
  }];
  cov_266ufwtch6.s[22]++;
  $scope.itemSelectedChampPerso = {};
  cov_266ufwtch6.s[23]++;
  $scope.hidesubPanel = function () {
    cov_266ufwtch6.f[1]++;
    cov_266ufwtch6.s[24]++;

    $scope.show_champsperso = false;
    cov_266ufwtch6.s[25]++;
    $scope.show_geographiclevel = false;
    cov_266ufwtch6.s[26]++;
    $scope.show_geographicplan = false;
  };
  cov_266ufwtch6.s[27]++;
  $scope.getAllChampPerso = function () {
    cov_266ufwtch6.f[2]++;
    cov_266ufwtch6.s[28]++;

    if ($scope.champPerso) {
      cov_266ufwtch6.b[1][0]++;
      cov_266ufwtch6.s[29]++;

      $scope.champPerso.isloading = true;
    } else {
      cov_266ufwtch6.b[1][1]++;
    }
    cov_266ufwtch6.s[30]++;
    $CRUDService.getAll($scope.PATHCHAMP, { get: 'all' }, function (data) {
      cov_266ufwtch6.f[3]++;
      cov_266ufwtch6.s[31]++;

      for (var i = 0; i < data.length; i++) {
        cov_266ufwtch6.s[32]++;

        data[i].hideEditor = true;
        cov_266ufwtch6.s[33]++;
        data[i].aggregation = $scope.listAggregation[data[i].AGGRE - 1];
      }
      cov_266ufwtch6.s[34]++;
      $scope.listChampPerso = data;

      cov_266ufwtch6.s[35]++;
      if ($scope.champPerso) {
        cov_266ufwtch6.b[2][0]++;
        cov_266ufwtch6.s[36]++;

        $scope.champPerso.isloading = false;
      } else {
        cov_266ufwtch6.b[2][1]++;
      }
    });
  };
  cov_266ufwtch6.s[37]++;
  $scope.openChampPerso = function () {
    cov_266ufwtch6.f[4]++;
    cov_266ufwtch6.s[38]++;

    $uibModal.open({
      templateUrl: 'app/geographic_map/personnal.html',
      controller: geographic_mapCtrl_champ,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInLeft right-modal'
    });
  };

  cov_266ufwtch6.s[39]++;
  $scope.actionLabel = {
    ADD: $translate.instant('GEOGRAPHIC_PLAN.ADD__'),
    LEVEL: $translate.instant('MENU.S_G'),
    CUSTOM: $translate.instant('GEOGRAPHIC_PLAN.CHAMPPERSO'),
    IMPORT: $translate.instant('GEOGRAPHIC_PLAN.IMPORT')
  };
  cov_266ufwtch6.s[40]++;
  $scope.openGeoLevel = function () {
    cov_266ufwtch6.f[5]++;
    cov_266ufwtch6.s[41]++;

    $uibModal.open({
      templateUrl: 'app/geographic_map/level.html',
      controller: geographic_mapCtrl_level,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInLeft right-modal'
    });
  };
  cov_266ufwtch6.s[42]++;
  $scope.openPlanGeoEdit = function () {
    cov_266ufwtch6.f[6]++;
    cov_266ufwtch6.s[43]++;

    $uibModal.open({
      templateUrl: 'app/geographic_map/edit.html',
      controller: geographic_mapCtrl_edit,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_266ufwtch6.s[44]++;
  $scope.selectItem = function (item) {
    cov_266ufwtch6.f[7]++;
    cov_266ufwtch6.s[45]++;

    $scope.itemSelectedChampPerso = {
      id: item.id,
      LIBELLE_CHAMPSPERSO: item.LIBELLE_CHAMPSPERSO,
      ID_PROJET: item.ID_PROJET,
      AGGRE: item.AGGRE,
      LEVEL_CHAMPSPERSO: item.LEVEL_CHAMPSPERSO,
      CODE_NG: item.CODE_NG
    };
  };
  // Niveau géographique
  cov_266ufwtch6.s[46]++;
  $scope.listGeoLevel = [];
  cov_266ufwtch6.s[47]++;
  $scope.itemSelectedNG = {};
  cov_266ufwtch6.s[48]++;
  $scope.hideAdd = true;
  cov_266ufwtch6.s[49]++;
  $scope.isloadingNG = true;
  cov_266ufwtch6.s[50]++;
  $scope.maxLength = 30;
  cov_266ufwtch6.s[51]++;
  $scope.minLength = 0;
  cov_266ufwtch6.s[52]++;
  $scope.getAllNG = function () {
    cov_266ufwtch6.f[8]++;
    cov_266ufwtch6.s[53]++;

    $scope.isloadingNG = true;
    cov_266ufwtch6.s[54]++;
    $CRUDService.getAll($scope.PATHNG, { get: 'all' }, function (data) {
      cov_266ufwtch6.f[9]++;
      cov_266ufwtch6.s[55]++;

      for (var i = 0; i < data.length; i++) {
        cov_266ufwtch6.s[56]++;

        data[i].hideEditor = true;
        cov_266ufwtch6.s[57]++;
        data[i].LONG_NG = eval(data[i].LONG_NG);
      }
      cov_266ufwtch6.s[58]++;
      $scope.listGeoLevel = data;
      cov_266ufwtch6.s[59]++;
      $scope.isloadingNG = false;
    });
  };
  cov_266ufwtch6.s[60]++;
  $scope.canAddNewNG = function () {
    cov_266ufwtch6.f[10]++;
    cov_266ufwtch6.s[61]++;

    $otherHttpService.post($scope.PATHNG, { action: 'canAddNew' }, function (data) {
      cov_266ufwtch6.f[11]++;
      cov_266ufwtch6.s[62]++;

      $scope.hideAdd = data != 0;
    });
  };
  cov_266ufwtch6.s[63]++;
  $scope.showNiveauGeo = function (value) {
    cov_266ufwtch6.f[12]++;
    cov_266ufwtch6.s[64]++;

    $scope.show_geographiclevel = angular.isUndefined(value) ? (cov_266ufwtch6.b[3][0]++, !$scope.show_geographiclevel) : (cov_266ufwtch6.b[3][1]++, value);
    cov_266ufwtch6.s[65]++;
    $scope.show_champsperso = false;
  };

  // uploadfile
  var uploader = (cov_266ufwtch6.s[66]++, $scope.uploader = new FileUploader({
    url: $CRUDService.getServerAdress() + 'data/web_server.php?action=loadcsvFile&method=1&' + $CRUDService.getComplement(0, $scope.PATHNG),
    alias: 'fileCVSPlanGeo',
    removeAfterUpload: true
  }));
  cov_266ufwtch6.s[67]++;
  uploader.onAfterAddingFile = function (fileItem) {
    cov_266ufwtch6.f[13]++;
    cov_266ufwtch6.s[68]++;

    fileItem.upload();
  };
  cov_266ufwtch6.s[69]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_266ufwtch6.f[14]++;
  };
  cov_266ufwtch6.s[70]++;
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    cov_266ufwtch6.f[15]++;
  };

  // Plan géographique
  cov_266ufwtch6.s[71]++;
  $scope.planItem = {};

  cov_266ufwtch6.s[72]++;
  $scope.edit = function (item, fils) {
    cov_266ufwtch6.f[16]++;

    var el = (cov_266ufwtch6.s[73]++, {});
    // scope.hidesubPanel();
    cov_266ufwtch6.s[74]++;
    $scope.editOption = true;
    // $scope.show_geographicplan=true;
    cov_266ufwtch6.s[75]++;
    if (!item) {
      cov_266ufwtch6.b[4][0]++;
      cov_266ufwtch6.s[76]++;
      // Ajouter first level
      el = {
        CARAC_L: '',
        CODE_LC: '',
        FIXE: '',
        NG: $scope.listGeoLevel[0],
        CODE_LP: null,
        CODE_NG: $scope.listGeoLevel[0].id,
        DESCRIPTION_L: '',
        PARAMLOC1: null,
        PARAMLOC2: null,
        PARAMLOC3: null,
        PARAMLOC4: null,
        PARAMLOC5: null,
        expanded: false,
        id: 0,
        leaf: $scope.listGeoLevel.length == 1
      };
      /* if (el.id == 0) {
       } */
    } else {
        cov_266ufwtch6.b[4][1]++;
        cov_266ufwtch6.s[77]++;
        if (fils) {
          cov_266ufwtch6.b[5][0]++;
          cov_266ufwtch6.s[78]++;
          // add fils
          el = {
            CARAC_L: '',
            CODE_LC: item.CODE_LC,
            FIXE: item.CODE_LC,
            CODE_LP: item.id,
            CODE_NG: null,
            DESCRIPTION_L: '',
            PARAMLOC1: null,
            PARAMLOC2: null,
            PARAMLOC3: null,
            PARAMLOC4: null,
            PARAMLOC5: null,
            expanded: false,
            id: 0
          };
          cov_266ufwtch6.s[79]++;
          for (var i = 0; i < $scope.listGeoLevel.length; i++) {
            cov_266ufwtch6.s[80]++;

            if ($scope.listGeoLevel[i].id == item.CODE_NG) {
              cov_266ufwtch6.b[6][0]++;
              cov_266ufwtch6.s[81]++;

              el.CODE_NG = $scope.listGeoLevel[i + 1].id;
              cov_266ufwtch6.s[82]++;
              el.NG = $scope.listGeoLevel[i + 1];
              cov_266ufwtch6.s[83]++;
              el.leaf = i + 2 == $scope.listGeoLevel.length;
              /* if (el.id == 0) {
               } */
              cov_266ufwtch6.s[84]++;
              break;
            } else {
              cov_266ufwtch6.b[6][1]++;
            }
          }
        } else {
          cov_266ufwtch6.b[5][1]++;
          cov_266ufwtch6.s[85]++;
          // Update
          el = {
            CARAC_L: item.CARAC_L,
            CODE_LC: item.CODE_LC,
            FIXE: item.CODE_LC,
            CODE_LP: item.CODE_LP,
            CODE_NG: item.CODE_NG,
            DESCRIPTION_L: item.DESCRIPTION_L,
            PARAMLOC1: item.PARAMLOC1,
            PARAMLOC2: item.PARAMLOC2,
            PARAMLOC3: item.PARAMLOC3,
            PARAMLOC4: item.PARAMLOC4,
            PARAMLOC5: item.PARAMLOC5,
            expanded: item.expanded,
            id: item.id
          };
          cov_266ufwtch6.s[86]++;
          for (var _i = 0; _i < $scope.listGeoLevel.length; _i++) {
            cov_266ufwtch6.s[87]++;

            if ($scope.listGeoLevel[_i].id == item.CODE_NG) {
              cov_266ufwtch6.b[7][0]++;
              cov_266ufwtch6.s[88]++;

              el.NG = $scope.listGeoLevel[_i];
              cov_266ufwtch6.s[89]++;
              el.leaf = _i + 1 == $scope.listGeoLevel.length;

              cov_266ufwtch6.s[90]++;
              break;
            } else {
              cov_266ufwtch6.b[7][1]++;
            }
          }
        }
      }cov_266ufwtch6.s[91]++;
    el.champs = [];
    cov_266ufwtch6.s[92]++;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = $scope.listChampPerso[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var elchamp = _step.value;
        cov_266ufwtch6.s[93]++;

        if (elchamp.CODE_NG == el.CODE_NG) {
          cov_266ufwtch6.b[8][0]++;
          cov_266ufwtch6.s[94]++;

          el.champs.push({
            label: elchamp.LIBELLE_CHAMPSPERSO,
            value: eval(el['PARAMLOC' + elchamp.LEVEL_CHAMPSPERSO]),
            level: elchamp.LEVEL_CHAMPSPERSO
          });
        } else {
          cov_266ufwtch6.b[8][1]++;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    cov_266ufwtch6.s[95]++;
    $scope.planItem = el;
    cov_266ufwtch6.s[96]++;
    if ((cov_266ufwtch6.b[10][0]++, el.CODE_LC == '') || (cov_266ufwtch6.b[10][1]++, el.id > 0)) {
      cov_266ufwtch6.b[9][0]++;
      cov_266ufwtch6.s[97]++;

      $scope.REGEX = '';
    } else {
      cov_266ufwtch6.b[9][1]++;
      cov_266ufwtch6.s[98]++;

      $scope.REGEX = new RegExp('^' + $scope.planItem.CODE_LC);
    }
    cov_266ufwtch6.s[99]++;
    $uibModal.open({
      templateUrl: 'app/geographic_map/edit.html',
      controller: geographic_mapCtrl_edit,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_266ufwtch6.s[100]++;
  $scope.deleteItem = function (item) {
    cov_266ufwtch6.f[17]++;

    var lasticone = (cov_266ufwtch6.s[101]++, item.icon);
    cov_266ufwtch6.s[102]++;
    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('GEOGRAPHIC_PLAN.CONFIRM_DELETE_LOCALTION'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_266ufwtch6.f[18]++;
      cov_266ufwtch6.s[103]++;

      if (!isconfirm) {
        cov_266ufwtch6.b[11][0]++;
        cov_266ufwtch6.s[104]++;

        return;
      } else {
        cov_266ufwtch6.b[11][1]++;
      }
      cov_266ufwtch6.s[105]++;
      item.icon = LOADING;
      var validateItem = (cov_266ufwtch6.s[106]++, {
        CARAC_L: item.CARAC_L,
        CODE_LC: item.CODE_LC,
        CODE_LP: item.CODE_LP,
        CODE_NG: item.CODE_NG,
        DESCRIPTION_L: item.DESCRIPTION_L,
        PARAMLOC1: item.PARAMLOC1,
        PARAMLOC2: item.PARAMLOC2,
        PARAMLOC3: item.PARAMLOC3,
        PARAMLOC4: item.PARAMLOC4,
        PARAMLOC5: item.PARAMLOC5,
        id: item.id
      });
      cov_266ufwtch6.s[107]++;
      $CRUDService.delet($scope.PATHPG, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_266ufwtch6.f[19]++;
        cov_266ufwtch6.s[108]++;

        item.icon = lasticone;
        cov_266ufwtch6.s[109]++;
        if (data < 0) {
          cov_266ufwtch6.b[12][0]++;
          cov_266ufwtch6.s[110]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });
          cov_266ufwtch6.s[111]++;
          $scope.isloading = false;
          cov_266ufwtch6.s[112]++;
          return;
        } else {
          cov_266ufwtch6.b[12][1]++;
        }
        cov_266ufwtch6.s[113]++;
        $deltaLocation.removeData(item);
      });
    });
  };

  cov_266ufwtch6.s[114]++;
  $scope.cancelItem = function () {
    cov_266ufwtch6.f[20]++;
    cov_266ufwtch6.s[115]++;

    $scope.planItem = {};
    cov_266ufwtch6.s[116]++;
    $scope.editOption = false;
    cov_266ufwtch6.s[117]++;
    $scope.show_geographicplan = false;
  };

  cov_266ufwtch6.s[118]++;
  $scope.canAddNewNG();
  cov_266ufwtch6.s[119]++;
  $scope.getAllChampPerso();
  cov_266ufwtch6.s[120]++;
  $scope.getAllNG();
  // $scope.getAllPLANGEO(0);
});

function geographic_mapCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService, $deltaLocation) {
  cov_266ufwtch6.f[21]++;
  cov_266ufwtch6.s[121]++;

  $scope.closeModal = function () {
    cov_266ufwtch6.f[22]++;
    cov_266ufwtch6.s[122]++;

    $scope.cancelItem();
    cov_266ufwtch6.s[123]++;
    $uibModalInstance.dismiss('cancel');
  };
  cov_266ufwtch6.s[124]++;
  $scope.checkCode = function () {
    cov_266ufwtch6.f[23]++;

    var lengthStr = (cov_266ufwtch6.s[125]++, $scope.planItem.FIXE.length);
    cov_266ufwtch6.s[126]++;
    if ($scope.planItem.CODE_LC.substring(0, lengthStr).toUpperCase() == $scope.planItem.FIXE.toUpperCase()) {
      cov_266ufwtch6.b[13][0]++;
      cov_266ufwtch6.s[127]++;

      return true;
    } else {
      cov_266ufwtch6.b[13][1]++;
    }
    cov_266ufwtch6.s[128]++;
    return false;
  };
  cov_266ufwtch6.s[129]++;
  $scope.validateItem = function () {
    cov_266ufwtch6.f[24]++;
    cov_266ufwtch6.s[130]++;

    // Verification
    // Code
    /* if($scope.planItem.CODE_LC.length!=$scope.planItem.NG.LONG_NG){
    return;
    }
    
    if($scope.planItem.CODE_LC.replace($scope.planItem.FIXE,"")==$scope.planItem.CODE_LC && $scope.planItem.FIXE!=""){
    
    return;
    } */
    if (!$scope.planItem.CODE_LC) {
      cov_266ufwtch6.b[14][0]++;
      cov_266ufwtch6.s[131]++;

      return;
    } else {
      cov_266ufwtch6.b[14][1]++;
    }
    cov_266ufwtch6.s[132]++;
    $scope.planItem.CODE_LC = $filter('uppercase')($scope.planItem.CODE_LC);
    cov_266ufwtch6.s[133]++;
    if ($scope.planItem.DESCRIPTION_L.trim().length == 0) {
      cov_266ufwtch6.b[15][0]++;
      cov_266ufwtch6.s[134]++;

      return;
    } else {
      cov_266ufwtch6.b[15][1]++;
    }
    cov_266ufwtch6.s[135]++;
    $scope.isloadingNG = true;
    var p = (cov_266ufwtch6.s[136]++, {
      id: $scope.planItem.id,
      PARAMLOC1: $scope.planItem.PARAMLOC1,
      PARAMLOC2: $scope.planItem.PARAMLOC2,
      PARAMLOC3: $scope.planItem.PARAMLOC3,
      PARAMLOC4: $scope.planItem.PARAMLOC4,
      PARAMLOC5: $scope.planItem.PARAMLOC5,
      CODE_LC: $scope.planItem.CODE_LC,
      DESCRIPTION_L: $scope.planItem.DESCRIPTION_L,
      CARAC_L: $scope.planItem.CARAC_L,
      CODE_NG: $scope.planItem.CODE_NG,
      CODE_LP: $scope.planItem.CODE_LP,
      leaf: $scope.planItem.leaf,
      expanded: false
    });
    cov_266ufwtch6.s[137]++;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = $scope.planItem.champs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var elchamp = _step2.value;
        cov_266ufwtch6.s[138]++;

        p['PARAMLOC' + elchamp.level] = elchamp.value;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    cov_266ufwtch6.s[139]++;
    $CRUDService.save($scope.PATHPG, { action: 'miseAJour', valeur: $filter('json')(p) }, function (data) {
      cov_266ufwtch6.f[25]++;
      cov_266ufwtch6.s[140]++;

      $scope.isloadingNG = false;
      cov_266ufwtch6.s[141]++;
      if (data < 0) {
        cov_266ufwtch6.b[16][0]++;
        cov_266ufwtch6.s[142]++;

        return;
      } else {
        cov_266ufwtch6.b[16][1]++;
      }
      var oldid = (cov_266ufwtch6.s[143]++, p.id);
      cov_266ufwtch6.s[144]++;
      if (oldid == 0) {
        cov_266ufwtch6.b[17][0]++;

        var parent = (cov_266ufwtch6.s[145]++, $filter('filter')($scope.listData_bksb, { id: p.CODE_LP }, true)[0]);
        cov_266ufwtch6.s[146]++;
        if (!parent) {
          cov_266ufwtch6.b[18][0]++;
          cov_266ufwtch6.s[147]++;

          p.id = data;
          cov_266ufwtch6.s[148]++;
          $deltaLocation.addData(p, $scope.planItem.NG.NIVEAU_NG, $scope.planItem.id != 0);
        } else {
            cov_266ufwtch6.b[18][1]++;
            cov_266ufwtch6.s[149]++;
            if (parent.isLoaded == true) {
              cov_266ufwtch6.b[19][0]++;
              cov_266ufwtch6.s[150]++;
              // Ajouter à la suite
              p.id = data;
              cov_266ufwtch6.s[151]++;
              $deltaLocation.addData(p, $scope.planItem.NG.NIVEAU_NG);
            } else {
              cov_266ufwtch6.b[19][1]++;
              cov_266ufwtch6.s[152]++;

              $scope.loadingData_bksb(parent);
            }
          }
      } else {
        cov_266ufwtch6.b[17][1]++;
        cov_266ufwtch6.s[153]++;

        $deltaLocation.addData(p, $scope.planItem.NG.NIVEAU_NG, $scope.planItem.id != 0);
      }
      cov_266ufwtch6.s[154]++;
      $scope.closeModal();
    });
  };
}

function geographic_mapCtrl_level($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate, $otherHttpService) {
  cov_266ufwtch6.f[26]++;
  cov_266ufwtch6.s[155]++;

  $scope.GeoLevel = {
    selectedItem: null,
    newItem: function newItem() {
      cov_266ufwtch6.s[156]++;

      this.editItem({
        id: 0,
        LONG_NG: $scope.listGeoLevel.length == 0 ? (cov_266ufwtch6.b[20][0]++, 1) : (cov_266ufwtch6.b[20][1]++, $scope.listGeoLevel[$scope.listGeoLevel.length - 1].LONG_NG + 1),
        NIVEAU_NG: $scope.listGeoLevel.length + 1
      });
    },
    editItem: function editItem(item) {
      cov_266ufwtch6.s[157]++;

      this.selectedItem = angular.copy(item);
      cov_266ufwtch6.s[158]++;
      this.selectedItem.hideEditor = false;
      cov_266ufwtch6.s[159]++;
      $scope.GeoLevel.listChampPersoTampon = [].concat($scope.listChampPerso);
      cov_266ufwtch6.s[160]++;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = $scope.GeoLevel.listChampPersoTampon[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _el = _step3.value;
          cov_266ufwtch6.s[161]++;

          _el.check = this.selectedItem.id == _el.CODE_NG;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      cov_266ufwtch6.s[162]++;
      if (this.selectedItem.id == 0) {
        cov_266ufwtch6.b[21][0]++;
        cov_266ufwtch6.s[163]++;

        this.selectedItem.maxLength = 30;
        cov_266ufwtch6.s[164]++;
        if ($scope.listGeoLevel.length == 0) {
          cov_266ufwtch6.b[22][0]++;
          cov_266ufwtch6.s[165]++;

          this.selectedItem.minLength = 1;
        } else {
          cov_266ufwtch6.b[22][1]++;
          cov_266ufwtch6.s[166]++;

          this.selectedItem.minLength = $scope.listGeoLevel[$scope.listGeoLevel.length - 1].LONG_NG + 1;
        }
      } else {
        cov_266ufwtch6.b[21][1]++;
        cov_266ufwtch6.s[167]++;

        for (var i = 0; i < $scope.listGeoLevel.length; i++) {
          var el = (cov_266ufwtch6.s[168]++, $scope.listGeoLevel[i]);
          cov_266ufwtch6.s[169]++;
          if (el.id == this.selectedItem.id) {
            cov_266ufwtch6.b[23][0]++;
            cov_266ufwtch6.s[170]++;

            if (i == 0) {
              cov_266ufwtch6.b[24][0]++;
              cov_266ufwtch6.s[171]++;

              this.selectedItem.minLength = 1;
            } else {
              cov_266ufwtch6.b[24][1]++;
              cov_266ufwtch6.s[172]++;

              this.selectedItem.minLength = $scope.listGeoLevel[i - 1].LONG_NG + 1;
            }
            cov_266ufwtch6.s[173]++;
            if (i == $scope.listGeoLevel.length - 1) {
              cov_266ufwtch6.b[25][0]++;
              cov_266ufwtch6.s[174]++;

              this.selectedItem.maxLength = 30;
            } else {
              cov_266ufwtch6.b[25][1]++;
              cov_266ufwtch6.s[175]++;

              this.selectedItem.maxLength = $scope.listGeoLevel[i + 1].LONG_NG - 1;
            }
            cov_266ufwtch6.s[176]++;
            break;
          } else {
            cov_266ufwtch6.b[23][1]++;
          }
        }
      }
    },
    cancelItem: function cancelItem() {
      cov_266ufwtch6.s[177]++;

      this.selectedItem = null;
    },
    validate: function validate() {
      var item = (cov_266ufwtch6.s[178]++, angular.copy(this.selectedItem));
      cov_266ufwtch6.s[179]++;
      $CRUDService.save($scope.PATHNG, { action: 'miseAJour', valeur: $filter('json')(item) }, function (data) {
        cov_266ufwtch6.f[27]++;
        cov_266ufwtch6.s[180]++;

        if ((cov_266ufwtch6.b[27][0]++, data == 0) || (cov_266ufwtch6.b[27][1]++, data == -2)) {
          cov_266ufwtch6.b[26][0]++;
          cov_266ufwtch6.s[181]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_UPDATE'),
            text: $translate.instant('GEOGRAPHIC_PLAN.ERROR_UPDATE_LONG')
          });
          cov_266ufwtch6.s[182]++;
          return;
        } else {
          cov_266ufwtch6.b[26][1]++;
        }
        cov_266ufwtch6.s[183]++;
        if (data < 1) {
          cov_266ufwtch6.b[28][0]++;
          cov_266ufwtch6.s[184]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_UPDATE'),
            text: $translate.instant('COMMON.TITLE_ERROR_ADD')
          });
          cov_266ufwtch6.s[185]++;
          return;
        } else {
          cov_266ufwtch6.b[28][1]++;
        }
        cov_266ufwtch6.s[186]++;
        $scope.GeoLevel.cancelItem();
        cov_266ufwtch6.s[187]++;
        $scope.GeoLevel.updatengChamPerso((cov_266ufwtch6.b[29][0]++, item.id) || (cov_266ufwtch6.b[29][1]++, data));
        cov_266ufwtch6.s[188]++;
        $scope.getAllNG();
      });
    },
    updatengChamPerso: function updatengChamPerso(id) {
      cov_266ufwtch6.s[189]++;

      if (id == 0) {
        cov_266ufwtch6.b[30][0]++;
        cov_266ufwtch6.s[190]++;

        return;
      } else {
        cov_266ufwtch6.b[30][1]++;
      }
      var listerso = (cov_266ufwtch6.s[191]++, []);
      cov_266ufwtch6.s[192]++;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.listChampPersoTampon[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var el = _step4.value;
          cov_266ufwtch6.s[193]++;

          if (el.check) {
            cov_266ufwtch6.b[31][0]++;
            cov_266ufwtch6.s[194]++;

            listerso.push(el.id);
          } else {
            cov_266ufwtch6.b[31][1]++;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      cov_266ufwtch6.s[195]++;
      $otherHttpService.post($scope.PATHCHAMP, { action: 'updateNG', idng: id, valeur: listerso.join(' , ') }, function (data) {
        cov_266ufwtch6.f[28]++;
        cov_266ufwtch6.s[196]++;

        $scope.getAllChampPerso();
      });
    },
    deleteItem: function deleteItem(item) {
      cov_266ufwtch6.s[197]++;

      SweetAlert.swal({
        title: $translate.instant('COMMON.CONFIRM'),
        text: $translate.instant('GEOGRAPHIC_PLAN.CONFIRM_DELETE_LEVEL'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
        confirmButtonText: $translate.instant('COMMON.YES'),
        cancelButtonText: $translate.instant('COMMON.NO'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_266ufwtch6.f[29]++;
        cov_266ufwtch6.s[198]++;

        if (!isconfirm) {
          cov_266ufwtch6.b[32][0]++;
          cov_266ufwtch6.s[199]++;

          return;
        } else {
          cov_266ufwtch6.b[32][1]++;
        }
        cov_266ufwtch6.s[200]++;
        $scope.isloadingNG = true;
        cov_266ufwtch6.s[201]++;
        $CRUDService.delet($scope.PATHNG, { action: 'supp', valeur: $filter('json')(item) }, function (data) {
          cov_266ufwtch6.f[30]++;
          cov_266ufwtch6.s[202]++;

          $scope.isloadingNG = false;
          cov_266ufwtch6.s[203]++;
          if (data < 1) {
            cov_266ufwtch6.b[33][0]++;
            cov_266ufwtch6.s[204]++;

            SweetAlert.swal({
              title: $translate.instant('COMMON.ERROR_DELETE'),
              text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
            });
            cov_266ufwtch6.s[205]++;
            return;
          } else {
            cov_266ufwtch6.b[33][1]++;
          }
          cov_266ufwtch6.s[206]++;
          $scope.getAllNG();
          cov_266ufwtch6.s[207]++;
          $scope.getAllChampPerso();
        });
      });
    },
    closeModal: function closeModal() {
      cov_266ufwtch6.s[208]++;

      $uibModalInstance.dismiss('cancel');
    }
  };
}

function geographic_mapCtrl_champ($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_266ufwtch6.f[31]++;
  cov_266ufwtch6.s[209]++;

  $scope.champPerso = {
    selectedItem: null,
    newItem: function newItem() {
      cov_266ufwtch6.s[210]++;

      this.editItem({
        id: 0,
        LIBELLE_CHAMPSPERSO: '',
        AGGRE: 1,
        aggregation: $scope.listAggregation[0],
        LEVEL_CHAMPSPERSO: $scope.listChampPerso.length + 1,
        CODE_NG: 0
      });
    },
    editItem: function editItem(item) {
      cov_266ufwtch6.s[211]++;

      this.selectedItem = angular.copy(item);
    },
    cancelItem: function cancelItem() {
      cov_266ufwtch6.s[212]++;

      this.selectedItem = null;
    },
    validate: function validate() {
      var item = (cov_266ufwtch6.s[213]++, angular.copy(this.selectedItem));
      cov_266ufwtch6.s[214]++;
      item.AGGRE = item.aggregation.id;
      cov_266ufwtch6.s[215]++;
      item.aggregation = undefined;
      cov_266ufwtch6.s[216]++;
      this.isloading = true;
      cov_266ufwtch6.s[217]++;
      $CRUDService.save($scope.PATHCHAMP, { action: 'MiseAJour', valeur: $filter('json')(item) }, function (data) {
        cov_266ufwtch6.f[32]++;
        cov_266ufwtch6.s[218]++;

        $scope.champPerso.isloading = false;
        cov_266ufwtch6.s[219]++;
        if (data == -10) {
          cov_266ufwtch6.b[34][0]++;
          cov_266ufwtch6.s[220]++;

          return;
        } else {
          cov_266ufwtch6.b[34][1]++;
        }
        cov_266ufwtch6.s[221]++;
        $scope.getAllChampPerso();
        cov_266ufwtch6.s[222]++;
        $scope.champPerso.cancelItem();
      });
    },
    deleteItem: function deleteItem(item) {
      cov_266ufwtch6.s[223]++;

      SweetAlert.swal({
        title: $translate.instant('COMMON.CONFIRM'),
        text: $translate.instant('GEOGRAPHIC_PLAN.CONFIRM_DELETE'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
        confirmButtonText: $translate.instant('COMMON.YES'),
        cancelButtonText: $translate.instant('COMMON.NO'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_266ufwtch6.f[33]++;
        cov_266ufwtch6.s[224]++;

        if (!isconfirm) {
          cov_266ufwtch6.b[35][0]++;
          cov_266ufwtch6.s[225]++;

          return;
        } else {
          cov_266ufwtch6.b[35][1]++;
        }
        cov_266ufwtch6.s[226]++;
        $scope.isloadingCP = true;
        cov_266ufwtch6.s[227]++;
        $CRUDService.delet($scope.PATHCHAMP, { action: 'supp', valeur: $filter('json')(item) }, function (data) {
          cov_266ufwtch6.f[34]++;
          cov_266ufwtch6.s[228]++;

          $scope.isloadingCP = false;
          cov_266ufwtch6.s[229]++;
          if (data == -10) {
            cov_266ufwtch6.b[36][0]++;
            cov_266ufwtch6.s[230]++;

            SweetAlert.swal({
              title: $translate.instant('COMMON.ERROR_DELETE'),
              text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
            });
            cov_266ufwtch6.s[231]++;
            return;
          } else {
            cov_266ufwtch6.b[36][1]++;
          }
          cov_266ufwtch6.s[232]++;
          $scope.getAllChampPerso();
        });
      });
    },
    closeModal: function closeModal() {
      cov_266ufwtch6.s[233]++;

      $uibModalInstance.dismiss('cancel');
    }
  };
}